export default "__VITE_ASSET__DcRtI1Yw__"